import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { userRegister } from './../../../apis/requests';
import { Link, useNavigate } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import dailCodes from './../../../assets/json/dailCodes.json';
import config from './../../../config/config.json';
import Select from 'react-select';
import { InputNumber } from "primereact/inputnumber";
import useLang from '../../../hooks/useLang';

const Register = () => {
    const { t } = useTranslation();
    const lang = useLang();
    const naviagte = useNavigate();
    const toast = useRef();
    const [username, setUsername] = useState();
    const [lastName, setLastName] = useState();
    const [phone, setPhone] = useState();
    const [email, setEmail] = useState();
    const [dailCode, setDailCode] = useState(config.defaultDailCode);
    const [password, setPassword] = useState();
    const [confirmpassword, setConfirmPassword] = useState();
    const [loading, setLoading] = useState(false);

    const handleRegister = async () => {
        try {
            if (password === confirmpassword) {
                setLoading(true);
                const data = {
                    email: email,
                    password: password,
                    name: username,
                    lastName:lastName,
                    phone: dailCode.dial_code + phone,
                }
                const res = await userRegister(data);
                setLoading(false);
                if (res.data === undefined) {
                    toast.current.show({ severity: 'error', summary: t('error'), detail: t('user_register_failed'), life: 3000 });
                } else {
                    naviagte('/register/success');
                }
            } else {
                toast.current.show({ severity: 'error', summary: t('error'), detail: t('password_mismatch'), life: 3000 });
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'ww', life: 3000 });

        }
    }
    return (
        <div className='mt-8 mb-8'>
            <Toast ref={toast} />
            <div className="flex justify-center">
                <div className='lg:p-8 p-4'>
                    <div className='login-container max-w-5xl'>
                        <div>
                            <form action=""
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    handleRegister();
                                }}
                            >
                                <h2 className='text-4xl mb-3'>{t('regsiter')}</h2>
                                <h6 className='text-2xl mb-3'>{t("enter_your_details_to_setup")}</h6>
                                <div className="grid lg:grid-cols-2 gap-2">
                                    <div className="form-group mb-2">
                                        <label htmlFor="userName" className='required'>{t('name')}</label>
                                        <InputText className='pr-input' required
                                            value={username}
                                            onChange={(e) => {
                                                setUsername(e.target.value);
                                            }}
                                        />
                                    </div>
                                    <div className="form-group mb-2">
                                        <label htmlFor="last_name" className='required'>{t('last_name')}</label>
                                        <InputText className='pr-input' required
                                            value={lastName}
                                            onChange={(e) => {
                                                setLastName(e.target.value);
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="form-group mb-2">
                                    <label htmlFor="email" className='required'>{t('email')}</label>
                                    <InputText className='pr-input' required
                                        value={email}
                                        onChange={(e) => {
                                            setEmail(e.target.value);
                                        }}
                                        type='email'
                                    />
                                </div>
                                <div>
                                    <div className="form-group">
                                        <label htmlFor="mobileNumber" className='required mb-1'>{t('mobile_number')}</label>
                                        <div className="p-inputgroup flex-1">
                                            <Select
                                                className='w-40'
                                                placeholder={t('select')}
                                                options={dailCodes}
                                                value={dailCode}
                                                getOptionLabel={(d) => d.dial_code}
                                                getOptionValue={(d) => d.dial_code}
                                                onChange={(e) => {
                                                    setDailCode(e)
                                                }}
                                                styles={{
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        padding: 2,
                                                        marginTop: 5,
                                                        borderRight: lang === "en" ? 'none' : "auto",
                                                        borderRadius: 0,
                                                        borderTopLeftRadius: lang === "en" ? 6 : 0,
                                                        borderBottomLeftRadius: lang === "en" ? 6 : 0,
                                                        borderTopRightRadius: lang === "en" ? 0 : 6,
                                                        borderBottomRightRadius: lang === "en" ? 0 : 6,
                                                    }),
                                                    menu: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        direction: 'ltr'
                                                    }),
                                                    valueContainer: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        direction: 'ltr'
                                                    }),
                                                }}
                                            />
                                            <InputNumber
                                                value={phone}
                                                onChange={(e) => {
                                                    setPhone(e.value);
                                                }}
                                                className='pr-input'
                                                useGrouping={false}
                                                inputStyle={{
                                                    borderTopLeftRadius: lang === "en" ? 0 : 6,
                                                    borderBottomLeftRadius: lang === "en" ? 0 : 6,
                                                    borderTopRightRadius: lang === "en" ? 6 : 0,
                                                    borderBottomRightRadius: lang === "en" ? 6 : 0,
                                                    borderRight: lang === "en" ? 'auto' : "none",
                                                    borderLeft: 'auto'
                                                }}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group mt-2">
                                    <label htmlFor="password" className='required'>{t('password')}</label>
                                    <Password className='pr-input'
                                        value={password}
                                        required
                                        onChange={(e) => {
                                            setPassword(e.target.value);
                                        }}
                                        feedback={false}
                                    />
                                </div>
                                <div className="form-group mt-2">
                                    <label htmlFor="confirmPassword" className='required'>{t('confirm_password')}</label>
                                    <Password className='pr-input'
                                        value={confirmpassword}
                                        required
                                        onChange={(e) => {
                                            setConfirmPassword(e.target.value);
                                        }}
                                        feedback={false}
                                    />
                                </div>
                                <div className="form-group mt-4">
                                    <Button label={t('register_account')}
                                        type='submit'
                                        loading={loading}
                                        rounded
                                    />
                                </div>
                                <div className='mt-4'>
                                    <h3><Link to='' className='mx-2 link'>{t('accepting_terms_n_conditions')}</Link></h3>
                                </div>
                            </form>
                        </div>
                        <div className='hidden lg:block md:block'>
                            <div className='text-center'>
                                <img src="/img/login.jpg" alt=""
                                    className='w-100'
                                />
                                <h3>{t('have_an_account_already')}<Link to='/login' className='mx-2 link'>{t('login_here')}</Link></h3>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}
export default Register;